import { Group, Select, SelectProps, Stack, Text } from '@mantine/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useCreateStore } from '@/store/create';

export const DEFAULT_MODEL_NAME = 'text-embedding-ada-002';

const SvgSelectCheck = () => (
  <svg viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="m_8ee53fc2">
    <path
      d="M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    ></path>
  </svg>
);

export const renderSelectOption: SelectProps['renderOption'] = ({ checked, option }) => {
  const customOption = option as { label: string; value: string; desc: string };

  return (
    <Group gap={10}>
      {checked && <SvgSelectCheck />}
      <Stack gap={2}>
        <Text size="sm">{customOption.label}</Text>
        <Text c="gray.5" size="xs">
          {customOption.desc}
        </Text>
      </Stack>
    </Group>
  );
};

export const ModelSelect = () => {
  const { t } = useTranslation();
  const { datasetId, datasetModelName, embeddingModelName, setEmbeddingModelName } = useCreateStore();

  // 是否是本地部署模式，是的话，使用本地Text Embedding
  const isLocalMode = import.meta.env.VITE_MODE === 'local';

  // 检查URL中是否存在id参数
  const urlParams = new URLSearchParams(window.location.search);
  const urlId = urlParams.get('botId');

  const MODEL_SELECT_DATA = useMemo(() => {
    return [
      {
        label: `text-embedding-3-small`,
        value: 'text-embedding-3-small',
        desc: t('dataset.model_desc.small'),
      },
      {
        label: `text-embedding-3-large`,
        value: 'text-embedding-3-large',
        desc: t('dataset.model_desc.large'),
      },
      {
        label: `BAAI/bge-m3-multi`,
        value: 'BAAI/bge-m3-multi',
        desc: t(
          'dataset.model_desc.bge_m3',
          'Multilingual embedding model with 1024 dimensions, optimized for performance'
        ),
      },
      {
        label: `text-embedding-ada-002`,
        value: 'text-embedding-ada-002',
        desc: t('dataset.model_desc.ada'),
      },
    ];
  }, [t]);

  if (isLocalMode) {
    return null;
  }

  return (
    <Stack gap={8}>
      <div className="mt-4">
        {datasetId && !urlId ? (
          <Group gap={0}>
            <Text size="sm">{`${t('dataset.model')}`}</Text>
            <Text size="sm" c="gray.5">
              {datasetModelName}
            </Text>
          </Group>
        ) : (
          <>
            <h3 className="gray.8">{t('dataset.model_select.title')}</h3>
            <Text c="gray.5" size="sm">
              {t('dataset.model_select.desc')}
            </Text>
          </>
        )}
      </div>

      {!datasetId && (
        <Select
          className="mb-3"
          data={MODEL_SELECT_DATA}
          allowDeselect={false}
          disabled={!!datasetId}
          value={embeddingModelName}
          onChange={(value) => {
            if (!value) return;
            setEmbeddingModelName(value);
          }}
          renderOption={renderSelectOption}
        ></Select>
      )}
    </Stack>
  );
};
